import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b4fe8fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "expertise-selection__categories" }
const _hoisted_6 = { class: "expertise-selection__title" }
const _hoisted_7 = { class: "expertise-selection__title-text" }
const _hoisted_8 = { class: "profile-creation-wizard__content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_step_mobile_header = _resolveComponent("step-mobile-header")!
  const _component_categorization_details_skeleton = _resolveComponent("categorization-details-skeleton")!
  const _component_categorization_prediction = _resolveComponent("categorization-prediction")!
  const _component_categorization_manual_selection = _resolveComponent("categorization-manual-selection")!
  const _component_categorization_level_selection = _resolveComponent("categorization-level-selection")!
  const _component_step_actions = _resolveComponent("step-actions")!
  const _component_categorization_side = _resolveComponent("categorization-side")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_progress_bar, { percentage: _ctx.progressPercentage }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step_mobile_header, {
            "step-name": _ctx.stepName,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "onClick:previous"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.expertise.title')), 1),
              _createElementVNode("div", {
                class: "expertise-selection__title-tag responsive-content",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPrevious && _ctx.goToPrevious(...args)))
              }, _toDisplayString(_ctx.creationForm.headline), 1)
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_categorization_details_skeleton, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.hasPredictions && !_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_categorization_prediction, {
                  key: 1,
                  predictions: _ctx.predictions,
                  categories: _ctx.creationForm.familiesCategoriesEdition.allSelectedCategories(),
                  onInputFamilyCategory: _ctx.selectFamilyAndCategory,
                  onManualSelection: _ctx.switchToManualSelection,
                  onPredictionSelection: _ctx.predictionSelection
                }, null, 8, ["predictions", "categories", "onInputFamilyCategory", "onManualSelection", "onPredictionSelection"]))
              : _createCommentVNode("", true),
            (!_ctx.hasPredictions && !_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_categorization_manual_selection, {
                  key: 2,
                  families: _ctx.families,
                  "preferred-family": _ctx.creationForm.familiesCategoriesEdition.preferredFamily(),
                  categories: _ctx.creationForm.familiesCategoriesEdition.allSelectedCategories(),
                  hadPredictions: _ctx.hadPredictions,
                  suggestedCategory: _ctx.creationForm.familiesCategoriesEdition.suggestedCategory(),
                  "closest-parent-selector": "div.profile-creation-wizard",
                  "bottom-sheet-selector": "#expertise-details-bottom-sheet",
                  "data-heap-tooltip-id": "profile-creation-tooltip-expertise-details-manual-selection",
                  onInputFamily: _ctx.manualSelectFamily,
                  onInputCategory: _ctx.manualSelectCategory,
                  onOtherCategoryChange: _ctx.manualSelectOtherCategory,
                  onUnselectCategories: _ctx.manualUnselectCategories,
                  onGoBack: _ctx.getPredictions,
                  onManualSelection: _ctx.manualSelection
                }, null, 8, ["families", "preferred-family", "categories", "hadPredictions", "suggestedCategory", "onInputFamily", "onInputCategory", "onOtherCategoryChange", "onUnselectCategories", "onGoBack", "onManualSelection"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_categorization_level_selection, {
                key: 0,
                class: "experience-level-selection",
                "bottom-sheet-selector-prop": "#expertise-details-experience-bottom-sheet",
                "data-heap-tooltip-id-prop": "profile-creation-tooltip-expertise-details-experience"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_joy_progress_bar, {
            percentage: _ctx.progressPercentage,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(_component_step_actions, {
            "step-name": _ctx.stepName,
            "is-disabled-button-next": !_ctx.hasValidFieldPart,
            "onClick:next": _ctx.goNext,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "is-disabled-button-next", "onClick:next", "onClick:previous"])
        ])
      ]),
      _createVNode(_component_categorization_side)
    ])
  ]))
}